import React from "react";

interface Tab {
  value: string;
  label: string;
}

interface TabsProps {
  activeTab: string;
  tabs: (Tab | null | undefined)[];
  setActiveTab: (tabId: string) => void;
}

export const Tabs: React.FC<TabsProps> = ({
  activeTab,
  tabs,
  setActiveTab,
}) => {
  return (
    <div className="w-full border-b border-neutral-200">
      <div className="flex flex-row min-h-fit overflow-x-auto scrollbar-hide">
        {tabs
          .filter((tab): tab is Tab => Boolean(tab))
          .map((tab, index) => (
            <div
              key={index}
              className="flex min-h-fit flex-row gap-4 flex-shrink-0"
            >
              <button
                id={tab.value}
                className={`px-0 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-colors duration-200 ${
                  activeTab === tab.value
                    ? "border-neutral-900 text-neutral-900"
                    : "border-neutral-100 text-neutral-400  hover:border-neutral-300"
                }`}
                onClick={() => setActiveTab(tab.value)}
              >
                {tab.label}
              </button>
              <div className="border-b-2 w-4 border-transparent"></div>
            </div>
          ))}
      </div>
    </div>
  );
};
